module.exports = __webpack_public_path__ + "img/flightaway_logo.7d419b0f.svg";